import { useEffect } from "react";
import { BRAND } from "../../types";

interface SpecialRequestProps {
  /** 订单详情中的特殊需求（用于回显） */
  defaultValue?: string;
}

export function SpecialRequest({ defaultValue }: SpecialRequestProps) {
  // 回显已有特殊需求
  useEffect(() => {
    if (defaultValue) {
      const textarea = document.querySelector("#special-request-textarea") as HTMLTextAreaElement;
      if (textarea && !textarea.value) {
        textarea.value = defaultValue;
      }
    }
  }, [defaultValue]);

  return (
    <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
      <div className="text-sm font-bold text-gray-900 mb-2">
        <i
          className="ri-chat-3-line mr-1.5"
          style={{ color: BRAND, fontSize: 15 }}
        />
        特殊需求（选填）
      </div>
      <textarea
        id="special-request-textarea"
        className="w-full text-sm text-gray-700 outline-none resize-none"
        style={{
          background: "#F8F9FC",
          borderRadius: 12,
          padding: "10px 14px",
          border: "1px solid #F0F0F0",
          fontSize: 13,
        }}
        placeholder="如：儿童餐椅、轮椅服务、饮食禁忌等..."
        rows={3}
        maxLength={500}
        defaultValue={defaultValue || ""}
      />
    </div>
  );
}
